import React, { useEffect, useState } from 'react';
import './FaqsPopup.css'; // Make sure the CSS file is in the same directory
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FAQS_LIST } from './Keywords';
import { useUserAuth } from "../context/UserAuthContext";

const FaqsPopup = ({ isVisible, onClose, onSelectNote}) => {
  const { userDataLocal } = useUserAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [isVisibleFAQs, setIsVisibleFAQs] = React.useState(false);
  const [faqList, setFaqList] = useState(FAQS_LIST['en-US']);
  const [formData, setFormData] = useState({
    name: userDataLocal?.Name,
    email: userDataLocal?.Email,
    phone: '',
    subject: '',
    message: ''
  });

  useEffect(() => {
    setIsVisibleFAQs(true);
    const lancode = userDataLocal?.Language.code;
    if (FAQS_LIST[lancode].length < 2) { 
      setFaqList(FAQS_LIST['en-US']);
    } else {
      setFaqList(FAQS_LIST[lancode]);
    }
    
    return () => {
      setIsVisibleFAQs(false);
    };
  }, []);

  function handleClose () {
    setIsVisibleFAQs(false);
    onClose();
  }

  // if (!isVisible) {
  //   setIsVisibleFAQs(false);
  //   // return null;
  // }
  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    fetch('https://springai.pythonanywhere.com/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then((data) => {
        alert('Email sent successfully!');
        setFormData({
          name: userDataLocal?.Name,
          email: userDataLocal?.Email,
          phone: '',
          subject: '',
          message: ''
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Email sending failed!');
      });
  };



    return (
      <div className={`popup-background-FAQs ${isVisibleFAQs ? 'active' : ''}`}>
          <div className='popup-FAQs'>
            <div className='header-FAQs'>
              <h1 className='h1-FAQs'>FAQs</h1>

              <span className="close-FAQs" onClick={handleClose}>&times;</span>
            </div>
            <div className="content-FAQs">
              {faqList.map((faq, index) => {
                const key = Object.keys(faq)[0];
                const value = faq[key];

                return (
                  <div key={index}>
                    <div className="date-header-FAQs">{key}</div>
                    <div className="note-container-FAQs">
                      {Array.isArray(value) ? value.flatMap((item, idx, arr) => {
                        const [boldPart, rest] = item.split(/:(.+)/);
                        return [
                          <div key={idx}><strong>{boldPart}:</strong>{rest}</div>,
                          idx < arr.length - 1 ? <br /> : null
                        ];
                      }) : <div>{value}</div>}
                    </div>
                  </div>
                );
              })}
              <div className="container-FAQs-Contact">
                {/* <div className="section-title-FAQs-Contact text-center-FAQs-Contact">
                  <span className="section-title__tagline-FAQs-Contact">Contact with us</span>
                  <h2 className="section-title__title-FAQs-Contact">Write us a message</h2>
                </div> */}
                <div className="date-header-FAQs">Contact with us</div>
                <div className="row">
                  <div className="col-xl-12">
                    <div className="contact-page__form-FAQs-Contact">
                      <form onSubmit={handleSubmit} className="comment-one__form-FAQs-Contact contact-form-validated-FAQs-Contact">
                        <div className="row">
                          <div className="col-xl-6">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <input
                                type="text"
                                name="name"
                                placeholder="Your name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <input
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <input
                                type="text"
                                name="phone"
                                placeholder="Phone number"
                                value={formData.phone}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <input
                                type="text"
                                name="subject"
                                placeholder="Subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <textarea
                                name="message"
                                placeholder="Write Message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                              ></textarea>
                            </div>
                            <button type="submit" className="thm-btn-FAQs-Contact faqs-contact__btn-FAQs-Contact">
                              <span>Send a message</span>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        {/* </div> */}
          
      </div>
      );
    };

export default FaqsPopup;